<template>
  <div>
    <div>
      <div class="row flex">
        <div class="card" style="flex: 1;">
          <div class="flex card-body">
            <a-row style="flex: 1">
              <a-col :sm="{span: 24}" :md="{span: 12}" style="display: flex; flex-direction: row">
                <div>
                  <div>Período</div>
                  <a-button :loading="salesStatsLoading" v-if="periodStats === 'custom'" @click="setPeriodToday">{{dateRangeText}} <a-icon type="close"></a-icon></a-button>
                  <a-popover v-else placement="bottomLeft" v-model="filterPeriodVisible">
                    <template slot="content">
                      <p>
                        <a-radio-group @change="changePeriod" v-model="periodStats">
                          <a-radio-button value="hoje">Últimas 24 horas</a-radio-button>
                          <a-radio-button value="past_7">Últimos 7 dias</a-radio-button>
                          <a-radio-button value="past_15">Últimos 15 dias</a-radio-button>
                          <a-radio-button value="past_30">Últimos 30 dias</a-radio-button>
                        </a-radio-group>
                      </p>
                    </template>
                    <template slot="title">
                      <span>Filtro por tempo</span>
                    </template>
                    <a-button type="primary" size="large" :loading="salesStatsLoading">
                      {{periodMap[periodStats]}}
                    </a-button>
                    <!-- <a-button size="large"> 02/10/2020 a 20/10/2020 <a-icon type="right" /> </a-button> -->
                  </a-popover>
                </div>
                <div style="padding-left: 10px; display: flex; align-items: center">
                  ou <a-range-picker @change="dateRangeSelected" v-model="rangePicker">
                        <span>
                          <a href="#" class="text-info" style="text-decoration: underline; margin-left: 5px">período personalizado</a>
                        </span>
                    </a-range-picker>
                </div>
              </a-col>
              <a-col :sm="{span: 24}" :md="{span: 12}">
                <div>Oferta</div>
                <a-select
                  :placeholder="offerSelectedDropdown"
                  @change="changedOffer"
                  v-model="selectedOffers"
                  style="width: 100%"
                  :loading="isLoadingOffers"
                >
                  <a-select-option :value="undefined" :key="18273">Todas Ofertas</a-select-option>
                  <a-select-option v-for="offer of allOffers" :key="offer.id" :value="offer.id">{{offer.name}}</a-select-option>
                </a-select>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="row flex">
        <a-row style="flex: 1">
          <a-col :sm="{span: 24}" :md="{span: 16}">
            <div class="card">
              <div class="card-body">
                <VueApexCharts ref="salesChart" type="bar" height="350" :options="salesChartOptions" :series="salesSeries"></VueApexCharts>
              </div>
            </div>
          </a-col>
          <a-col :sm="{span: 24}" :md="{span: 8}">
            <div class="card" style="margin-bottom: 0.6rem !important">
              <div class="card-body text-center">
                <a-spin size="large" v-if="salesStatsLoading"></a-spin>
                <div v-else>
                  <TodaySalesWidget :title="currentStatsTitle" :subtitle="dateRangeText" :amount="'R$'+formatPagarmeMoney(mainStatsTotal)"></TodaySalesWidget>
                  <TodaySalesWidget title="Pedidos Aprovados" :amount="totalOrderQty"></TodaySalesWidget>
                </div>
              </div>
            </div>
            <div class="card" style="margin-bottom: 0.6rem !important">
              <div class="card-body">
                <div class="d-flex" style="flex: 1">
                        <div class="text-left text-uppercase text-dark font-weight-bold mb-1" style="flex: 1">ticket médio</div>
                        <div class="text-info font-weight-bold font-size-24 mb-0 text-right" style="flex: 1">R${{formatMoney(kpiStats.average_ticket)}}</div>
                    </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body text-center">
                <a-spin size="large" v-if="salesStatsLoading"></a-spin>
                <SalesWidget>
                  <div class="flex" style="flex-direction: column; flex: 1">
                    <div>
                      <div class="progress mb-2">
                        <div class="progress-bar bg-info" :style="{width: `${kpiCardApproved}%`}"></div>
                      </div>
                    </div>
                    <div class="d-flex mb-4" style="flex: 1">
                        <div class="text-left text-uppercase text-dark font-weight-bold mb-1" style="flex: 1">aprovação do cartão</div>
                        <div class="text-info font-weight-bold font-size-18 mb-0 text-right" style="flex: 1">
                          {{kpiCardApproved}}%
                        </div>
                    </div>
                    <div>
                      <div class="progress mb-2">
                        <div class="progress-bar bg-info" :style="{width: `${kpiStats.boleto_approval}%`}"></div>
                      </div>
                    </div>
                    <div class="d-flex mb-4" style="flex: 1">
                        <div class="text-left text-uppercase text-dark font-weight-bold mb-1" style="flex: 1">aprovação de boleto</div>
                        <div class="text-info font-weight-bold font-size-18 mb-0 text-right" style="flex: 1">
                          {{kpiStats.boleto_approval}}%
                        </div>
                    </div>
                    <div>
                      <div class="progress mb-2">
                        <div class="progress-bar bg-info" :style="{width: `${kpiStats.refunded_rate}%`}"></div>
                      </div>
                    </div>
                    <div class="d-flex mb-4" style="flex: 1">
                        <div class="text-left text-uppercase text-dark font-weight-bold mb-1" style="flex: 1">taxa de reembolso</div>
                        <div class="text-info font-weight-bold font-size-18 mb-0 text-right" style="flex: 1">
                          {{kpiStats.refunded_rate}}%
                        </div>
                    </div>
                    
                  </div>
                </SalesWidget>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getSalesByDay, getTodaySales, getKpiApprovedStats, getSalesByHour, getKpiStats } from '@/services/report'
import { getAllGroups } from '@/services/offer'
import TodaySalesWidget from '@/components/kiwi/KStatsWidget.vue'
import SalesWidget from '@/components/kiwi/KContentWidget.vue'
import VueApexCharts from 'vue-apexcharts'
import dayjs from 'dayjs'
import moment from 'moment-timezone'
import 'dayjs/locale/pt-br';
dayjs.locale('pt-br');

export default {
  components: {
    TodaySalesWidget,
    SalesWidget,
    VueApexCharts,
  },
  data(){
    return {
      offerSelectedDropdown: 'Carregando ofertas...',
      start_period: dayjs().valueOf(),
      end_period: dayjs().valueOf(),
      mainStatsTotal: 0,
      totalOrderQty: 0,  
      isLoadingOffers: true,
      filterPeriodVisible: false,
      salesStatsLoading: false,
      allOffers: [],
      rangePicker: undefined,
      dateStats: undefined,
      periodStats: 'hoje',
      customPeriod: undefined,
      selectedOffers: undefined,
      kpiCardApproved: 0,
      kpiStats: {
        boleto_approval: 0,
        average_ticket: 0,
        chargeback_rate: 0,
        refunded_rate: 0,
      },
      salesSeries: [{
            name: 'Vendas',
            data: [],
      }],
      salesChartOptions: {
        colors: ['#42a848'],
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          type: 'category',
          labels: {
            style: {
              fontSize: '16px',
            },
          },
        },
        yaxis: {
          title: {
            text: 'R$ (vendas)',
          },
          labels: {
            style: {
              fontSize: '14px',
            },
            formatter: function (value) {
              return "R$"+value.toLocaleString('pt-BR', { minimumFractionDigits: 2}); 
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "R$ " + val.toLocaleString('pt-BR', { minimumFractionDigits: 2})
            },
          },
          style: {
            fontSize: '16px',
          },
        },
        noData: {
          text: 'Carregando dados...',
        },
      },
      stats: {
        salesToday: 0,
      },
      periodMap: {
        'hoje': 'Últimas 24 horas',
        'past_7': 'Últimos 7 Dias',
        'past_15': 'Últimos 15 Dias',
        'past_30': 'Últimos 30 Dias',
        'custom': 'Período: ',
      },
    }
  },
  methods: {
    changedOffer(){
      // this.salesStatsLoading = true;
      this.loadStats(this.periodStats)
    },
    closeFilterPop(){
      this.filterPeriodVisible = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSelectedOffers(offers){
      this.selectedOffers = offers;
    },
    async setPeriodToday(){
      this.periodStats = 'hoje';
      this.rangePicker = undefined;
      await this.getStatsPerHour();
    },
    async dateRangeSelected(){

      this.salesStatsLoading = true;

      this.periodStats = 'custom';

      const dates = this.rangePicker;
      const daysDifference = dates[1].diff(dates[0], 'days');

      this.start_period = dates[0].startOf('day').valueOf();
      this.end_period = dates[1].endOf('day').valueOf();

      const { data } = await getSalesByDay(this.start_period, this.end_period, this.selectedOffers, this.token);
      const lastMonthSeries = this.prepareSeries(data, Math.round(daysDifference), 'DD MMM');
      
      this.changeSeries(lastMonthSeries);

      this.salesStatsLoading = false;

    },
    async loadStats(loadType){
      switch(loadType){
        case "custom":
          this.dateRangeSelected().then(() => {});
          break;
        case "hoje":
          this.getStatsPerHour().then(() => {
          })
          break;
        case "past_7":
          this.getWeekSales().then(() => {
          })
        break;
        case "past_15":
          this.get15days().then(() => {
          })
          break;
        case "past_30":
          this.get30days().then(() => {
          })
          break;
      }

      
      // this is triggered when a date is changed
      this.getKpiStats().then(() => {})
      this.getKpiDatedStats().then(() => {})
    },
    async getKpiDatedStats(){
      let offer = '';
      if(this.selectedOffers){
        offer = this.selectedOffers;
      }

      const kpiApprovedCard = await getKpiApprovedStats(this.start_period, this.end_period, this.token, offer)
      this.kpiCardApproved = kpiApprovedCard.data['credit_card_approval'] || 0;
      this.$set(this.kpiStats, 'average_ticket', kpiApprovedCard.data['average_ticket']);
    },
    async getKpiStats(){

      let offer = '';
      if(this.selectedOffers){
        offer = this.selectedOffers;
      }
      const kpiData = await getKpiStats(this.token, offer)
      //kpiStats
      this.kpiStats = kpiData.data;
    },
    changePeriod(e){
      this.closeFilterPop();
      this.loadStats(e.target.value);
    },
    returnSubtractedDate(value, type, formatTxt){
      switch(type){
        case "date":
          return dayjs().subtract(value, 'day').format(formatTxt)
        case "week":
          return dayjs().subtract(value, type).format(formatTxt)
        case "month":
          return dayjs().subtract(value, type).format(formatTxt)
      }
    },
    returnTimePeriodStats(timeArray){
      let timePeriodsStats = {};
      timeArray.forEach((time) => {
        timePeriodsStats[time] = {
          x: time,
          y: 0,
        };
      })
      return timePeriodsStats;
    },
    returnTimePeriodArray(timeAgo, typeDate, formatDate){

      let timePeriodArray = [];

      for(let x=0; x<timeAgo; x++) {
        timePeriodArray.push(this.returnSubtractedDate(x, typeDate, formatDate));
      }
      return timePeriodArray;
    },
    prepareSeries(dataArray, timeQty, formatTxt){

      this.resetTotal();

      const lastMonth = this.returnTimePeriodArray(timeQty, 'date', formatTxt);
      lastMonth.reverse();
      const lastMonthStats = this.returnTimePeriodStats(lastMonth);
      const lastMonthSeries = [];

      dataArray.forEach((dayStats) => {
        let dayMonth = dayjs(dayStats.order_date).format(formatTxt)
        lastMonthStats[dayMonth] = {
          x: dayMonth,
          y: dayStats.total/100,
        };
        this.sumToTotal(dayStats.total)
        this.sumOrderQty(dayStats.qty);
      })
      lastMonth.forEach((days) => {
        lastMonthSeries.push(lastMonthStats[days])
      })
      return lastMonthSeries;

    },
    async get30days(){

      this.salesStatsLoading = true;

      // TODO: transformar o today em variável do Vue normal
      const today = dayjs().valueOf();
      const month_day_ago = parseInt(moment().subtract(1, 'months').format("x"));

      this.start_period = month_day_ago;
      this.end_period = today;

      const { data } = await getSalesByDay(month_day_ago, today, this.selectedOffers, this.token);

      const lastMonthSeries = this.prepareSeries(data, 31, 'DD MMM');
      this.changeSeries(lastMonthSeries);

      this.salesStatsLoading = false;

    },
    async get15days(){

      this.salesStatsLoading = true;

      // TODO: transformar o today em variável do Vue normal
      const today = dayjs().valueOf();
      const fifteen_days_ago = dayjs().startOf('day').subtract(15, 'day').valueOf();

      this.start_period = fifteen_days_ago;
      this.end_period = today;

      const { data } = await getSalesByDay(fifteen_days_ago, today, this.selectedOffers, this.token);

      const lastDaysSeries = this.prepareSeries(data, 16, 'DD MMM');
      this.changeSeries(lastDaysSeries);

      this.salesStatsLoading = false;

    },
    async getWeekSales(){

      this.salesStatsLoading = true;
      
      const today = dayjs().valueOf();
      const week_ago = dayjs().startOf('day').subtract(1, 'week').valueOf();

      this.start_period = week_ago;
      this.end_period = today;
    
      const { data } = await getSalesByDay(week_ago, today, this.selectedOffers, this.token);

      const lastWeekSeries = this.prepareSeries(data, 8, 'DD MMM');
      this.changeSeries(lastWeekSeries);

      this.salesStatsLoading = false;
      
    },
    changeSeries(series){
      this.$refs.salesChart.updateSeries([{
        name: 'Vendas',
        data: series,
      }])
    },
    changeCategories(categories){
      this.$set(this.salesChartOptions, 'xaxis', {
        categories: categories,
      });
    },
    formatMoney(money){
      if(money){
        return money.toLocaleString('pt-BR', { minimumFractionDigits: 2}); 
      }
      return "0,00";
    },
    formatPagarmeMoney(value){
      let valor = value/100;
      return  this.formatMoney(valor)
    },

    resetTotal(){
      this.mainStatsTotal = 0;
      this.totalOrderQty = 0;
    },
    sumOrderQty(qtyTotal){
      this.totalOrderQty += parseInt(qtyTotal);
    },
    sumToTotal(sumTotal){
      this.mainStatsTotal += parseInt(sumTotal);
    },
    async getStatsPerHour(){

      this.start_period = dayjs().subtract(24, 'hour').valueOf();
      this.end_period = dayjs().valueOf();

      this.resetTotal();
      this.salesStatsLoading = true;

      const last24hours = [];
      let last24HoursSeries = [];
      const last24hoursStats = {};
      const timeNow = dayjs();

      for(let x=0; x<24; x++) {
        const hour = timeNow.subtract(x, 'hour').hour();
        last24hours.push(hour);
        last24hoursStats[hour] = 0;
      }
      //reverte a ordem do array
      last24hours.reverse();

      const allDaySales = await getSalesByHour(dayjs().valueOf(), this.selectedOffers, this.token);
      console.log({allDaySales})
      allDaySales.data.forEach((salesTotal) => {

        last24hoursStats[salesTotal.hora] = salesTotal.total/100
        this.sumToTotal(salesTotal.total);
        this.sumOrderQty(salesTotal.qty);
      })
      last24hours.forEach((hour) => {
        last24HoursSeries.push({
          x: `${hour}h`,
          y: last24hoursStats[hour],
        })
      })
      this.changeSeries(last24HoursSeries);
      this.salesStatsLoading = false;

    },
  },
  watch: {
    async end_period() {
      await this.getKpiDatedStats();
    },
  },
  computed: {
    ...mapGetters(['token','user','completed_signup']),
    userv2(){
      return this.authUser['https://admin-api-dot-kiwicheckout.appspot.com/user_v2'];
    },
    authUser(){
      return this.$auth.user;
    },
    storeType(){
      if(this.authUser){    
        return this.authUser['https://admin-api-dot-kiwicheckout.appspot.com/store_type'] || 'standard';
      }else{
        return 'elite';
      }
    },
    dateRangeText() {
      if(this.rangePicker){
        let rDates = this.rangePicker;
        return rDates[0].format("DD/MM/YYYY")+" a "+rDates[1].format("DD/MM/YYYY")
      }
      return '';
    },
    currentStatsTitle(){
      return this.periodMap[this.periodStats]
    },
  },
  async mounted(){
    
    this.salesStatsLoading = true;

    let statsCategoriesDays = []
    let statsCategoriesDayTotal = {};
    for(let n=0; n<30; n++){
      let dayFormat = dayjs().subtract(n, 'day').format("YYYY-MM-DD")
      statsCategoriesDays.push(dayFormat);
      statsCategoriesDayTotal[dayFormat] = 0;
    } 

    setTimeout(async () => {

      const kpiData = await getKpiStats(this.token)
      this.kpiStats = kpiData.data;

      const allOffers = await getAllGroups(this.token)
      this.offerSelectedDropdown = 'Selecione a oferta aqui';  
      this.isLoadingOffers = false;

      const {data} = allOffers;
      this.allOffers = data;

      await this.getStatsPerHour();
      
      const allTodaySales = await getTodaySales(this.selectedOffers, this.token) 
      console.log({allTodaySales});
      this.stats.salesToday = parseInt(allTodaySales.data[0].total)

    }, 1000);
  },
}
</script>

<style>
.kiwi-link{
  color: white;
}
.kiwi-link:hover{
  color: white;
}
</style>